import { render, staticRenderFns } from "./checkDetail.vue?vue&type=template&id=66126ac4&scoped=true"
import script from "./checkDetail.vue?vue&type=script&lang=js"
export * from "./checkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66126ac4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66126ac4')) {
      api.createRecord('66126ac4', component.options)
    } else {
      api.reload('66126ac4', component.options)
    }
    module.hot.accept("./checkDetail.vue?vue&type=template&id=66126ac4&scoped=true", function () {
      api.rerender('66126ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/currencyManagement/checkDetail.vue"
export default component.exports